<template>
  <div class="pc_page">
    <!-- 头部 -->
    <!-- <AboutHeader></AboutHeader> -->
    <Header></Header>
    <div style="margin-top: 60px;">
      <nut-swiper :pagination-visible="true" style="margin-top: 60px;" height="200" pagination-color="#426543" auto-play="3000">
        <nut-swiper-item v-for="(item, index) in bannerList" :key="index">
          <div class="pic_item">
            <span class="english_first_title">{{ item.english_first_title }}</span>
            <span class="english_secord_title">{{ item.english_secord_title }}</span>
            <span class="title">{{ item.title }}</span>
            <img :src='item.imgUrl' style="max-width:100%;max-height:100%;object-fit:cover;" alt="">
          </div>
        </nut-swiper-item>
        
      </nut-swiper>
    </div>
    
    <!-- 产品案例 -->
    <div class="product">
      <div class="product_top">
        <p class="product_title">产品案例</p>
        <p class="product_en_title">Product Case</p>
        <div class="line"></div>
      </div>
      <div class="product_top_img" @click="goProductDetail(11)">
        <div class="product_img_text">
          <p class="product_img_title">企业数字档案系统</p>
          <p class="product_img_info">为了更好的扶持自贸区企业的发展，提供更全面更便捷的服务</p>
        </div>
        <img src="../assets/images/111.jpg" class="img" alt="">
      </div>
      <div class="product_list">
        <div class="oversize" @click="goProductDetail(19)">
          <img src="../assets/images/555.jpg" alt="">
          <div class="img_bg"></div>
        </div>
        <div class="oversize" @click="goProductDetail(20)">
          <img src="../assets/images/222.jpg" alt="">
          <div class="img_bg"></div>
        </div>
        <div class="oversize" @click="goProductDetail(10)">
          <img src="../assets/images/333.jpg" alt="">
          <div class="img_bg"></div>
        </div>
        <div class="oversize" @click="goProductDetail(18)">
          <img src="../assets/images/444.jpg" alt="">
          <div class="img_bg"></div>
        </div>
      </div>
    </div>
    <!-- 中部轮播 -->
    <div class="center_banner">
      <nut-swiper :pagination-visible="true" height="200" pagination-color="#426543" auto-play="3000">
        <nut-swiper-item v-for="(item, index) in swiperList" :key="index">
          <img :src="item.imgUrl" style="width:100%;height:100%;object-fit:cover;" alt="" />
        </nut-swiper-item>
      </nut-swiper>
    </div>
    <!-- 公司动态 -->
    <div class="company">
      <div class="company_top">
          <p class="company_title">公司动态</p>
          <p class="company_en_title">Company dynamics</p>
          <div class="line"></div>
        </div>
    </div>
    <!-- 新闻列表 -->
    <div class="news">
      <div class="news_item" v-for="(item, index) in articleList" :key="index">
        <router-link :to=" { path:'/newsDetails', query: {id: item.id} } ">
          <img :src="item.image" alt="">
          <div class="news_info">
            <p class="news_title">{{ item.topic }}</p>
            <p class="news_date">{{ item.createTime }}</p>
            <p class="news_desc">{{ item.description }}</p>
          </div>
        </router-link>
      </div>
      
    </div>
  <!-- 底部 -->
  <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/page/Footer.vue";
import Header from "@/components/page/Header.vue";
import AboutHeader from "@/components/page/AboutHeader.vue";
import { getArticleList } from "@/api/app.js";
export default {
  name: 'Home',
  components: {
    Footer,
    Header,
    AboutHeader
  },
  data() {
    return {
      queryParams: {
        limit: 3,
        page: 1
      },
      articleList: [],
      bannerList: [
        {
          imgUrl: require("../assets/images/1.jpg"),
          english_first_title: 'Blockchain',
          english_secord_title: 'information security leader',
          title: '区块链信息安全引领者',
        },
        {
          imgUrl: require("../assets/images/2.jpg"),
          english_first_title: 'Pioneer in the',
          english_secord_title: 'field of big data technology',
          title: '大数据技术领域开拓者',
        },
        {
          imgUrl: require("../assets/images/3.jpg"),
          english_first_title: 'The creator of',
          english_secord_title: 'the whole value chain credit ecosystem',
          title: '全价值链信用生态系统创造者',
        },
      ],
      swiperList: [
        {imgUrl: require("../assets/images/11.jpg")},
        {imgUrl: require("../assets/images/22.jpg")},
        {imgUrl: require("../assets/images/33.jpg")},
      ],
    }
  },
  created() {
    this.getArticleList();
  },
  methods: {
    // 获取新闻列表
    getArticleList() {
      getArticleList(this.queryParams).then(res => {
        this.articleList = res.list;
      });
    },
    // 跳转产品详情页
    goProductDetail(id) {
      this.$router.push({
        path: 'productDetails',
        query: {id: id}
      });
    },
  }
}
</script>
<style scoped>
.pic_item {position: relative;width: 100%;}
.pic_item .english_first_title {color: #555555;font-weight: 500;display: block;position: absolute;left: 40px;top: 150px;text-align: center;font-size: 36px;line-height: 40px;}
.pic_item .english_secord_title {color: #555555;font-weight: 600;display: block;position: absolute;left: 40px;top: 190px;text-align: center;font-size: 36px;line-height: 40px;}
.pic_item .title {position: absolute;top: 250px;left: 40px;display: block;text-align: center;font-size: 36px;line-height: 44px;color: #2d58c6;font-weight: 600;letter-spacing: 12px;}
.pic_item img {display: block;height: 600px;width: 100%;}
.pc_page .product {
  margin-top: 40px;
}
.pc_page .product .product_top {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.pc_page .product .product_top .product_title {
  font-size: 36px;
  font-weight: 800;
  color: #2d58c6;
}
.pc_page .product .product_top .product_en_title {
  margin-top: 8px;
  font-size: 10px;
  color: #cccccc;
  letter-spacing: 1px;
  margin-bottom: 26px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: Roboto, Roboto-Medium;
}
.pc_page .product .product_top .line {
  width: 96px;
  height: 4px;
  background: #cccccc;
  margin-bottom: 40px;
}
.pc_page .product .product_top_img {
  padding: 0 32px;
  box-sizing: border-box;
  position: relative;
}
.pc_page .product .product_top_img .product_img_text {
  position: absolute;
  bottom: 40px;
  left: 50px;
  color: #fff;
  z-index: 999;
}
.pc_page .product .product_top_img .img {
  width: 100%;
  height: 100%;
}
.pc_page .product .product_top_img .product_img_text .product_img_title {
  line-height: 45px;
  font-size: 30px;
  font-weight: 800;
}
.pc_page .product .product_top_img .product_img_text .product_img_info {
  line-height: 24px;
  margin-top: 6px;
  font-size: 16px;
  color: #dddddd;
}
.pc_page .product .product_list {
  margin-top: 20px;
  padding: 0 32px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.pc_page .product .product_list .oversize {
  width: 328px;
  height: 328px;
  margin-bottom: 30px;
  position: relative;
}
.pc_page .product .product_list img {
  width: 100%;
  height: 100%;
  display: block;
}
.img_bg {
  position: absolute;
  height: 50%;
  width: 100%;
  bottom: 0;
  left: 0;
  background-image:-o-linear-gradient((to top, rgba(0, 0, 0,0.6), transparent));
  background-image:-webkit-linear-gradient((to top, rgba(0, 0, 0,0.6), transparent));
  background-image:-moz-linear-gradient((to top, rgba(0, 0, 0,0.6), transparent));
  background-image:linear-gradient(to top, rgba(0, 0, 0,0.6), transparent);
}
.pc_page .center_banner {
  margin-top: 30px;
}
.pc_page .company {
  margin-top: 40px;
}
.pc_page .company .company_top {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.pc_page .company .company_top .company_title {
  font-size: 36px;
  font-weight: 800;
  color: #2d58c6;
}
.pc_page .company .company_top .company_en_title {
  margin-top: 8px;
  font-size: 10px;
  color: #cccccc;
  letter-spacing: 1px;
  margin-bottom: 26px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: Roboto, Roboto-Medium;
}
.pc_page .company .company_top .line {
  width: 96px;
  height: 4px;
  background: #cccccc;
  margin-bottom: 40px;
}
.pc_page .news {
  padding: 0 32px;
  box-sizing: border-box;
  margin-top: 40px;
}
.pc_page .news .news_item {
  margin-bottom: 30px;
  background: #f8f8f8;
}
.pc_page .news .news_item img {
  display: block;
  width: 686px;
  height: 350px;
}
.pc_page .news .news_item .news_info {
  padding: 20px;
  box-sizing: border-box;
}
.pc_page .news .news_item .news_info .news_title {
  font-size: 32px;
  font-weight: 700;
  color: #333333;
  text-align: justify;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.pc_page .news .news_item .news_info .news_date {
  margin-top: 10px;
  font-size: 24px;
  color: #333333;
}
.pc_page .news .news_item .news_info .news_desc {
  margin-top: 15px;
  font-size: 24px;
  color: #666666;
  text-align: justify;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

</style>
